import { Badge, Button, ColorSwatch, Group, Stack, Table, Text, UnstyledButton, useMantineTheme } from '@mantine/core';
import { IconExternalLink } from '@tabler/icons-react';
import dayjs from 'dayjs';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ClientConnectionItem, useCollaborateStore, adjustToBrowserTimezone } from '@mygpt/app';

interface VisitorTableProps {
  data: ClientConnectionItem[];
  highlightedId?: string;
}

const VisitorTable: React.FC<VisitorTableProps> = ({ data, highlightedId }) => {
  const { t } = useTranslation();

  const theme = useMantineTheme();
  const navigate = useNavigate();
  const { isAssist } = useCollaborateStore();

  const highlightAnimation = `
  @keyframes highlight {
    0%, 50%, 100% { background-color: transparent; }
    25%, 75% { background-color: ${theme.colors.yellow[2]}; }
  }
`;

  return (
    <div>
      <style>{highlightAnimation}</style> {/* 将动画添加到组件中 */}
      <Table>
        <Table.Thead className="bg-gray-300">
          <Table.Tr>
            <Table.Th>{t('visitors.table.id')}</Table.Th>
            <Table.Th>{t('visitors.table.channel')}</Table.Th>
            <Table.Th>{t('visitors.table.host')}</Table.Th>
            <Table.Th>{t('visitors.table.type')}</Table.Th>
            <Table.Th>{t('visitors.table.seen')}</Table.Th>
            <Table.Th>{t('visitors.table.action')}</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {data.map((item) => (
            <Table.Tr
              key={item.connection_id}
              className={item.connection_id === highlightedId ? 'highlight-animation' : ''} // 如果 ID 匹配，则添加动画类名
              style={{ animation: item.connection_id === highlightedId ? 'highlight 4s ease-in-out' : undefined }} // 应用动画
            >
              <Table.Td>
                <Group>
                  <ColorSwatch color={item.connection_id ? theme.colors.green[5] : theme.colors.gray[2]} size={10} />
                  <Stack gap={0}>
                    <Text>{item.email || item.user_id || 'user'}</Text>
                  </Stack>
                </Group>
              </Table.Td>
              <Table.Td>
                {item.page_url ? (
                  <UnstyledButton
                    onClick={() => {
                      window.open(item.page_url);
                    }}
                  >
                    <Badge variant="filled" rightSection={<IconExternalLink size={15} />}>
                      {t('completions.source')}
                    </Badge>
                  </UnstyledButton>
                ) : (
                  ''
                )}
              </Table.Td>
              <Table.Td>{item.client_addr}</Table.Td>
              <Table.Td>
                {item.session_type === 'shared' && t('visitors.table.type_shared')}
                {item.session_type === 'widget' && t('visitors.table.type_widget')}
              </Table.Td>
              <Table.Td>{dayjs(adjustToBrowserTimezone(item.created_at)).format('YYYY-MM-DD HH:mm:ss')}</Table.Td>
              <Table.Td>
                <Button
                  variant="outline"
                  size="xs"
                  onClick={() => {
                    navigate(`/${isAssist ? 'assist' : 'bot'}/${item.ai_id}/records?sessionId=${item.session_id}`);
                  }}
                >
                  {t('create_v2.documents.details')}
                </Button>
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </div>
  );
};

export default VisitorTable;
